import React from 'react';
import {FieldArray} from 'formik';
import SurveyParametersType from './SurveyParametersType';

const SurveyParametersSettingsForm = () => {
    return (
        <div className="form-group">
            <FieldArray name="parameters" component={SurveyParametersType} />
        </div>
    );
};

export default SurveyParametersSettingsForm;
